import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface IDeleteBlogStyleParams {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
}

interface IDeleteBlogStyleRequest {
	id: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function useDeleteBlogStyleMutation({ onError, onSuccess }: IDeleteBlogStyleParams = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async ({ id, impersonationContext }: IDeleteBlogStyleRequest) => {
			return userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `CustomPageStyle/${encodeURIComponent(id)}`,
				}),
				'DELETE'
			);
		},
		onError,
		onSuccess,
	});
}
